module.exports = __webpack_public_path__ + "img/mob4.eff43b23.png";